import { PaysafeConfig } from '../paysafe/paysafe-config.interface';
import { WorldpayConfig } from '../worldpay/worldpay-config.interface';

export type CheckoutCardConfig = PaysafeConfig | WorldpayConfig;
